import React from "react";
import { useTranslation } from "react-i18next";
import { ExpandMore } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./effective-work-days-header.style";
import chevronDown from "@iconify/icons-mdi/chevron-down";
import { InlineIcon } from "@iconify/react";
import { OcErrorBoundary } from "oc/components";

interface MyLeaveEffectiveWorkDaysHeaderProps {
  handleExpandClick: () => void;
  expanded: boolean;
  currentYearEffectiveWorkDays: number | null;
}

export const MyLeaveEffectiveWorkDaysHeader: React.FC<
  MyLeaveEffectiveWorkDaysHeaderProps
> = ({ handleExpandClick, expanded, currentYearEffectiveWorkDays }) => {
  const classes = useStyles(expanded);
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <OcErrorBoundary>
      <Box
        className={
          expanded === false
            ? classes.filterContainer
            : classes.openFilterContainer
        }
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Typography variant="body1" color={theme.palette.primary.main}>
            {t("MY_LEAVE_EFFECTIVE_WORK_DAY")}
          </Typography>
          <Box width="85px" display="flex" justifyContent="center">
            <Typography variant="h4" color={theme.palette.primary.main}>
              {currentYearEffectiveWorkDays?.toLocaleString()}
            </Typography>
          </Box>
        </Box>
        <IconButton
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
          style={
            expanded
              ? {
                padding: 0,
                transform: "rotate(180deg)",
              }
              : {
                padding: 0,
              }
          }
        >
          <InlineIcon
            icon={chevronDown}
            width="24px"
            style={{
              color: theme.palette.gray80.main,
            }}
          />
          <ExpandMore />
        </IconButton>
      </Box>
    </OcErrorBoundary>
  );
};

export default MyLeaveEffectiveWorkDaysHeader;
